<footer>
  <p>{{ applicationName | titlecase }} - Version: {{ applicationVersion }}</p>
  <p>AstraZeneca {{ copyrightYear }}</p>
</footer>
